import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const URL_BASE_MONITOREO = BASE_URL;
const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const obtenerCliente = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/cliente`, obtenerConfig());
        //console.log('WWJ00:', response.data);
        // filtrar el cliente 1 que no se debe mostrar
        const listaNueva = response.data.filter(item => item.clienteId !== 1)
        return listaNueva;
    } catch (error) {
        console.error('Error al consultar Clientes' + error.message);
        throw new Error('Error al consultar los Clientes');
    }
};

export const obtenerProyectosXCliente = async (clienteId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/proyecto/cliente/${clienteId}`, obtenerConfig());
        //console.log('XXJ00:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error al consultar Clientes' + error.message);
        throw new Error('Error al consultar los Clientes');
    }
};

export const registraCliente = async (objPost) => {
    //console.log('VVJJ01:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/cliente`, objPost, obtenerConfig());
        //console.log('VVJJ02:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al registrar Cliente' + error.message);
        throw new Error('Error al registrar Ciente');
    }
};

export const registraProyecto = async (objPost) => {
    //console.log('ZZJJ00:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/proyecto`, objPost, obtenerConfig());
        //console.log('ZZJJ02:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al registrar Proyecto' + error.message);
        throw new Error('Error al registrar Proyecto');
    }
};

export const registraPuesto = async (objPost) => {
    //console.log('QQJJ00:', objPost);
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/puesto`, objPost, obtenerConfig());
        //console.log('QQJJ01:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error al registrar Proyecto' + error.message);
        throw new Error('Error al registrar Proyecto');
    }
};

export const obtieneHoraDetalleDina = async (cabeceraId) => {
    //console.log ('XXJJ00:', cabeceraId)
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/horaDetDinamico/cabecera/${cabeceraId}`, obtenerConfig());
        //console.log('XXJ00:', response.data);
        return response.data;
    } catch (error) {
        
    }
}

export const obtieneDatosDetaDinamico = async (cabeceraId) => {
    const resultadoParalelo = await Promise.allSettled([
        axios.get(`${URL_BASE_MONITOREO}/horaDetDinamico/cabecera/${cabeceraId}`, obtenerConfig()),
        axios.get(`${URL_BASE_MONITOREO}/horaDetDinamico/empleados/${cabeceraId}`, obtenerConfig())
    ])
    const procesosNombre = ["datos detalle", "datos empleado"]
    const datosCorrectos = resultadoParalelo.map((res, index) => {
        if (res.status === 'fulfilled') {
            return res.value.data
        } else {
            console.error(`Error al procesar: ${procesosNombre[index]}`, res.reason)
            return null
        }
    })
    return datosCorrectos
}

export const obtieneDetaDinaPorFecha = async(feIni, feFin) => {
    //
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/horaDetDinamico/entreFechas/${feIni}/${feFin}`, obtenerConfig());
        return response.data;
    } catch (error) {
        throw new Error('Error al consultar por Fechas. ' + error.message);
    }
}

export const obtieneDatosDinaXPuesto = async (objData) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/horaDetDinamico/getDatosDinamicos`, objData, obtenerConfig());
        return response.data;
    } catch (error) {
        throw new Error('Error al consultar por Fechas. ' + error.message);
    }
}

export const registrarHoraDinamica = async (objPost) => {
    //console.log ('pJJ:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/horaDetDinamico/registrar`, objPost, obtenerConfig());
        //console.log ('pJJ:', response.data)
        return response.data
    } catch (error) {
        throw new Error(typeof error.response?.data === 'string' ? error.response.data : 'Error al registrar los horarios. ' + error.message);
    }
}

export const registraDinamiXCambio = async(objPost) => {
    console.log ('pJJ00:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/horaDetDinamico/registraXCambio`, objPost, obtenerConfig());
        console.log ('pJJ01:', response.data)
        return response.data
    } catch (error) {
        throw new Error('Error al registrar los horarios. ' + error.message);
    }
}